import { Component } from '@angular/core';
import {AlertController, LoadingController, NavParams, ToastController, ViewController} from 'ionic-angular';
import { LotteryService } from "../../services/lottery.services";
import { AppConfigService } from "../../services/appConfig.service";
import { AppDialog } from "../../component/appDialog";
import { CommonUtil } from "../../util/commonUtil";
import { SixMarkService } from "../../services/sixmark.services";
import { LotteryPage } from "../lottery/lottery";
import { UserService } from "../../services/user.services";
import * as common from "../../directives/common";
import { LoginPage } from "../login/login";
import { TranslateService } from 'ng2-translate';

@Component({
    templateUrl: 'betDetailsTrace.html',
    selector: 'bet-details-trace-page',
})
export class BetDetailsTracePage {
    private id: any;
    private betInfo: any;
    private traceInfo: any;
    private traceBetInfo: any;
    private delBtn: boolean = false;
    private revoke: any;
    private flag: string = "BetSub";

    isSMorTD: boolean = false;
    private winNumber = {
        nums: [],
        issue: ''
    };
    lotteryID: number;

    arrMMCGameID = [50, 100, 101, 102, 103, 104, 60, 80, 90, 91];

    isMMC: boolean = false;
    isMMC1Giay: boolean = false;
    public isTaiXiu: boolean = true;
    public isXocdia: boolean = true;
    public winnumberArr: any;
    private storeParams:any;
    public flagBtnHuyCuoc: boolean = true;
    private flagCheckCurLoginname: boolean = false;

    constructor(private lotteryService: LotteryService, private alertCtrl: AlertController, private loadingCtrl: LoadingController, public params: NavParams
        , private toastCtrl: ToastController, public viewCtrl: ViewController, private sixMarkService: SixMarkService, private userService: UserService, private translate: TranslateService) {
        if (params.data['fatherid'] === LoginPage.userID) {
            this.flagBtnHuyCuoc = false;
        }
        this.id = params.get('betId');
        this.revoke = params.get('revoke');
        this.storeParams = {
            id: params.get('betId')
        };
        this.isSMorTD = LotteryPage.isSMorTD;

        if (LotteryPage.isSMorTD) {
            this.getLotteryRecordInfoSM();
        } else {
            let id = this.storeParams['id'];
            if (id.substring(0, 1) == "B") {
                this.getLotteryRecordInfo();
            } else {
                this.flag = "TraceSub";
                this.getTraceRecordInfo();
            }
        }
    }

    getLotteryRecordInfoSM() {
        let dataParams = this.storeParams;
        this.sixMarkService.lotteryRecordBeanInfo(dataParams, this.alertCtrl).then((response: any) => {
            if (response) {
                if (response.status === 'success') {
                    this.betInfo = response.data.betinfo;
                    this.delBtn = this.betInfo.status == 0;
                }
            }
        });
    }

    getTraceRecordInfo(refresher?:any) {
        let dataParams = this.storeParams;
        this.userService.traceRecord(dataParams, this).then(data => {
            if (!data["msg"]) {
                if (data['curloginname'] !== '') this.flagCheckCurLoginname = true;
                this.traceInfo = data;
                this.traceInfo.trace["inserttime"] = this.traceInfo.trace["inserttime"].replace(/-/g, '/');
                this.traceBetInfo = this.traceInfo.betlist;
                if (typeof (this.traceBetInfo["codes"]) != "undefined") {
                    this.traceBetInfo["codes"] = this.traceBetInfo["codes"].replace(/&/g, ",").replace(/@/g, "\r\n");
                    let model = {
                        1: "元",
                        2: "角",
                        3: "分",
                        4: "厘"
                    };
                    this.traceBetInfo.betmodle = model[this.traceBetInfo.betmodle];
                }

                //代理查看
                if (this.revoke) {
                    this.delBtn = false;
                } else {
                    // this.delBtn = true;
                    this.delBtn = this.traceBetInfo['status'] == 0;
                }

                if (refresher) {
                    refresher.complete();
                }
            }
        });
    }

    doRefresh(refresher) {
        this.getTraceRecordInfo(refresher);
    }

    getLotteryRecordInfo() {
        let dataParams = this.storeParams;
        this.lotteryService.lotteryRecordBeanInfo(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.betInfo = data["betinfo"];
                this.betInfo['codes'] = this.betInfo['codes'].replace(/[&]/g, ',');
                this.betInfo["inserttime"] = this.betInfo["inserttime"].replace(/-/g, '/');
                this.checkMMCGame(Number(this.betInfo.lotteryid));
                if (this.isMMC1Giay) {
                    this.betInfo["issue"] = this.betInfo["inserttime"].substr(11);
                }

                this.betInfo["codes"] = this.betInfo["codes"].replace(/&&/g, " ").replace(/@/g, "\r\n");
                let model = {
                    1: "元",
                    2: "角",
                    3: "分",
                    4: "厘"
                };
                this.betInfo.betmodle = model[this.betInfo.betmodle];
                //代理查看
                if (this.revoke) {
                    this.delBtn = false;
                } else {
                    // this.delBtn = true;
                    this.delBtn = this.betInfo['status'] == 0;
                }

                if (this.isXocdia) {
                    let arr = Array.from(this.betInfo.winnumber);
                    this.winnumberArr = arr.filter((item) => item != '|');
                    this.betInfo["codes"] = this.betInfo["codes"].toLowerCase();
                    this.betInfo["codes"] = this.betInfo["codes"].replace(/bet/g, "Cược")
                                                                .replace(/prize/g, "Thắng")
                                                                .replace("white" , "Xanh")
                                                                .replace("red" , "Đỏ")
                                                                .replace(/1white3red/g , "1Xanh3Đỏ")
                                                                .replace(/3white1red/g , "3Xanh1Đỏ")
                                                                .replace("even" , "Chẵn")
                                                                .replace("odd" , "Lẻ");
                }
            }
        });
    }

    copy(url: string) {
        CommonUtil.copyToClipboard(url, this.toastCtrl);
    }

    deleteBet(event, idIssue) {
        let dataParams = {id: idIssue};
        this.lotteryService.lotteryCancelBet(dataParams, this).then(data => {
            if (data["msg"] === '') {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: this.translate.instant('SUCCESS')
                });
                setTimeout(() => {
                    this.getTraceRecordInfo();
                }, 2000);
            }else {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    detailView(event, winnumber, issue, lotteryid, methodid) {
        this.winNumber = {
            nums: winnumber.split(','),
            issue: issue
        };
        let strHtml =
            '<div class="resultTbl" id="resultTbl">' +
                '<div class="open__resulttbl">' +
                    common.displayIssue(winnumber.split(','),this.translate, lotteryid, methodid) +
                    common.separateType(winnumber.split(','), 0, this.translate) +
                '</div>' +
            '</div>';
        let alertCmp = this.alertCtrl.create({
            title: this.translate.instant('DRAW_RESULT') + " <span class='issue__name'>" + issue + "</span>",
            cssClass: 'custom-resultpopup',
            message: strHtml,
            buttons: [
                {
                    text: 'OK',
                    handler: data => {}
                }
            ]
        });
        alertCmp.present();
    }

    checkMMCGame(lotteryID: number) {
        if (lotteryID === 50 || lotteryID === 60 || lotteryID === 90 || lotteryID === 91) { // 1giay lottery and 1giay taixiu
            this.isMMC1Giay = true;
        }
        if (this.arrMMCGameID.indexOf(lotteryID) > -1) {
            this.isMMC = true;
        }

        if (common.checkGameTaiXiu(lotteryID)) {
            this.isTaiXiu = false;
        }

        this.isXocdia = common.checkGameXocDia(lotteryID);
    }
}



// WEBPACK FOOTER //
// ./src/pages/betDetailsTrace/betDetailsTrace.ts